var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '../styled-components';
var IconWrap = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  margin: auto 0;\n  min-width: 4rem;\n  text-align: center;\n  pointer-events: none;\n"], ["\n  color: ", ";\n  margin: auto 0;\n  min-width: 4rem;\n  text-align: center;\n  pointer-events: none;\n"])), function (p) { return p.theme.colorPrimary; });
export default IconWrap;
var templateObject_1;
